<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText"
    size="normal"
  >
    <template #header>
      <span>导入分配负责人</span>
    </template>
    <template #content>
      <gj-upload
        :template-url="`/operation/listing/downLoadProductChargeTemplate?productType=listingCharge`"
        @uploadAfter="uploadAfter"
        container-type="product"
        text="导入负责人"
        style="margin-bottom: 16px"
      >
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
        :rules="[
          '支持导入格式为xlsx的文件',
          '模版中的表头不可更改，不可删除',
          '店铺/国家+MSKU和负责人对应关系重复时，取最后一条记录',
          '导入已配对店铺/国家+MSKU和负责人对应关系，更新原来的对应关系',
          '负责人为空，则清除已配对的负责人',
        ]"
      >
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, uploadMixin } from '@/minxins';
import { postChargeInfo } from '@/api/sale';

export default {
  name: 'import-charge-template-modal',
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {};
  },
  methods: {
    /**
     * 上传回调
     * @param attachmentId
     */
    uploadAfter(attachmentId, data, uploadCb) {
      this.importHandleLoading = true;
      postChargeInfo(attachmentId)
        .then((res) => {
          this.$gjImportHandle(res, uploadCb);
        })
        .catch(() => {
          uploadCb('error');
        })
        .complete(() => (this.importHandleLoading = false));
    },
  },
};
</script>

<style scoped>
</style>
